import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { Observable } from 'rxjs';
import { UserQualificationsV2ListService } from '../../../../service/user-qualifications-v2-list.service';
import { BulkEditQualificationsService } from '../bulk-edit-qualifications.service';

@Component({
  selector: 'wilson-bulk-edit-qualifications-trigger',
  imports: [CommonModule, TranslatePipe, NzButtonModule, NzTooltipModule],
  templateUrl: './bulk-edit-qualifications-trigger.component.html',
  styleUrl: './bulk-edit-qualifications-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkEditQualificationsTriggerComponent {
  private readonly bulkEditQualificationsService = inject(
    BulkEditQualificationsService,
  );
  private readonly userQualificationsV2ListService = inject(
    UserQualificationsV2ListService,
  );

  public can = inject(AbilityServiceSignal).can;
  public readonly RoleAction = RoleAction;
  public readonly RolePermissionSubject = RolePermissionSubject;
  protected selectionCount$: Observable<{ count: number }> =
    this.userQualificationsV2ListService.selectedQualificationsCount$;

  public showBulkEditDrawer(): void {
    this.bulkEditQualificationsService.setBulkEditDrawerVisible(true);
  }
}
